import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '../Avatar';
import { getTagTitle } from '../../helpers/Search';

const FilterBubbles = ({ filters, onRemoveFilter }) => (
  <>
    {filters.map((filter, index) => (
      <div className="tag" key={`${filter.type}-${filter.key}`} title={getTagTitle(filter)}>
        {filter.type === 'people' && (
          <Avatar user={{ avatar_url: filter.image, name: filter.name }} size={20} />
        )}
        <span className="tag-label">
          {filter.label}
        </span>
        {/* eslint-disable jsx-a11y/click-events-have-key-events */}
        <span
          className="tag-remove"
          title="Remove"
          role="button"
          tabIndex={index}
          onClick={() => onRemoveFilter(filter.type, filter.key)}
        >
          <i className="far fa-times" />
        </span>
        {/* eslint-enable jsx-a11y/click-events-have-key-events */}
      </div>
    ))}
  </>
);

FilterBubbles.propTypes = {
  filters: PropTypes.array.isRequired,
  onRemoveFilter: PropTypes.func.isRequired,
};

export default FilterBubbles;
